<template>
  <h2 class="title">
    <router-link :to="{name: 'PersonInfo'}"  class="prev"></router-link>
    {{title}}
  </h2>
</template>

<script>
export default {
  name: 'personHead',
  data () {
    return {

    }
  },
  props: [
    'title'
  ]
}
</script>

<style scoped lang="stylus">
  .title
    position: relative
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .4rem
    color: #050505
    font-weight: 600
    text-align: center
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: #fff
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
</style>



// WEBPACK FOOTER //
// src/components/share/header/personHead.vue